import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LeafletModule } from '@asymmetrik/ngx-leaflet/dist/leaflet/leaflet.module';
import { MapaComponent } from './mapa.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    LeafletModule.forRoot(),
    TranslateModule,
  ],
  declarations: [
    MapaComponent,
],
  exports: [MapaComponent],
  bootstrap: [MapaComponent]
})
export class MapaModule { }



// WEBPACK FOOTER //
// ./src/app/main/components/mapa/mapa.module.ts